import { NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import ParkGuideDirectoryTemplate, {
  ParkGuideDirectoryPageData,
} from '@/components/templates/ParkGuideDirectoryTemplate';
import getPageData from '@/services/getPageData.js';

const ParkDirectory: NextPage<ParkGuideDirectoryPageData> = props => {
  const { title, seo_description, canonical_url } = props.metadata;

  return (
    <React.Fragment>
      <HeadMeta
        title={title}
        description={seo_description}
        canonicalUrl={canonical_url}
        noindex={!!props.fallback}
      />
      <ParkGuideDirectoryTemplate {...props} />
    </React.Fragment>
  );
};

ParkDirectory.getInitialProps = async ({ req, res, query }) => {
  const pageData = await getPageData({ req, res, query });

  return { ...pageData };
};
export default ParkDirectory;
